module.exports = __webpack_public_path__ + "autoalert-logo-lincoln-canada.abcae01160c7f53bb614.png";